import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { Loader, X } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { CONTEXT_CHIP_HEIGHT, CONTEXT_CHIP_MARGIN } from '../../rachelInput.styles';

interface RachelContextChipProps {
  label: string;
  onDismiss: () => void;
}

const RachelContextChip = ({ label, onDismiss }: RachelContextChipProps) => {
  const { translate } = useTranslation();

  return (
    <Stack
      test-id="rachel-context-chip"
      direction="row"
      alignItems="center"
      gap={1}
      sx={(theme) => ({
        height: CONTEXT_CHIP_HEIGHT,
        mx: `${CONTEXT_CHIP_MARGIN}px`,
        mt: `${CONTEXT_CHIP_MARGIN}px`,
        pl: 1,
        pr: 0.5,
        borderRadius: `${theme.shape.borderRadiusLg}px`,
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.text.secondary,
      })}
    >
      <Icon icon={Loader} size="xs" />
      <Typography noWrap variant="body2" color="text.secondary" title={label} sx={{ flex: 1 }}>
        {label}
      </Typography>
      <IconButton
        icon={X}
        size="small"
        testId="rachel-context-chip-dismiss"
        ariaLabel={translate(LangEnum.RACHEL_CONTEXT_CHIP_DISMISS)}
        onClick={onDismiss}
      />
    </Stack>
  );
};

export default RachelContextChip;
